import React from 'react'
import { FiBriefcase } from 'react-icons/fi'
import IconBackground from './IconBackground'

function InvoiceIcon({ size = 1, color = '#9c27b0' }) {
  return (
    <IconBackground size={size} color={color}>
      <FiBriefcase style={{ color: 'white' }} size={16 * size} />
    </IconBackground>
  )
}

export default InvoiceIcon
